/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/******** Code for product slider on homepage**********/
 jQuery().ready(function(){
  jQuery('.slick-carousel').slick({
    arrows: true,
    centerPadding: "0px",
    dots: false,
    slidesToShow: 3,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  });
});


$(document).ready(function (){
jQuery(".Popover__Value").click(function ()
//jQuery("form#product_form_7138780905642 .Popover__Value").click(function ()                                                                
{     
var variant = $(this).attr("data-value");
  if (variant == 'Black'){
  $(".brown-variant").css("display", "none");
  $(".dark-brown-variant").css("display", "none");
  $(".black-variant").css("display", "block");
  $(".medium-brown-variant").css("display", "none");
  $(".medium-blonde-variant").css("display", "none"); 
  $(".grey-variant").css("display", "none"); 
  $(".light-brown-variant").css("display", "none");  
  $(".dark-blonde-variant").css("display", "none"); 
   $(".black1-variant").css("display", "none"); 
   //alert('Black color');
  }
  else if(variant == 'Brown'){
   $(".black-variant").css("display", "none");
   $(".dark-brown-variant").css("display", "none");
   $(".brown-variant").css("display", "block");
   $(".medium-brown-variant").css("display", "none");
   $(".medium-blonde-variant").css("display", "none");
   $(".grey-variant").css("display", "none");
   $(".light-brown-variant").css("display", "none"); 
    $(".dark-blonde-variant").css("display", "none");
    $(".black1-variant").css("display", "none");
  //alert('brown color');
  }
 else if(variant == 'Dark Brown'){
   $(".dark-brown-variant").css("display", "block");
   $(".black-variant").css("display", "none");
   $(".brown-variant").css("display", "none");
   $(".medium-brown-variant").css("display", "none");
   $(".medium-blonde-variant").css("display", "none");
   $(".grey-variant").css("display", "none");
   $(".light-brown-variant").css("display", "none");
   $(".black1-variant").css("display", "none");
  //alert('Dark brown color');
  }
 else if(variant == 'Medium Brown'){
   $(".medium-brown-variant").css("display", "block");
   $(".black-variant").css("display", "none");
   $(".brown-variant").css("display", "none");
   $(".medium-blonde-variant").css("display", "none");
   $(".grey-variant").css("display", "none");
   $(".light-brown-variant").css("display", "none");
    $(".dark-brown-variant").css("display", "none");
   $(".black1-variant").css("display", "none");
  //alert('Medium brown color');
  } 
  else if(variant == 'Dark Blonde'){
   $(".dark-blonde-variant").css("display", "block");
   $(".black-variant").css("display", "none");
   $(".medium-brown-variant").css("display", "none");
   $(".brown-variant").css("display", "none");
   $(".medium-blonde-variant").css("display", "none");
   $(".grey-variant").css("display", "none");  
   $(".light-brown-variant").css("display", "none"); 
   $(".dark-brown-variant").css("display", "none");
    $(".black1-variant").css("display", "none");
  //alert('dark blonde color');
  }
 else if(variant == 'Medium Blonde'){
   $(".medium-blonde-variant").css("display", "block");
   $(".dark-blonde-variant").css("display", "none");
   $(".black-variant").css("display", "none");
   $(".medium-brown-variant").css("display", "none");
   $(".brown-variant").css("display", "none");
   $(".grey-variant").css("display", "none");
   $(".light-brown-variant").css("display", "none");
    $(".dark-brown-variant").css("display", "none");
   $(".black1-variant").css("display", "none");
  //alert('Medium blonde color');
  } 
 else if(variant == 'Grey'){
   $(".grey-variant").css("display", "block");
   $(".medium-blonde-variant").css("display", "none");
   $(".dark-blonde-variant").css("display", "none");
   $(".black-variant").css("display", "none");
    $(".medium-brown-variant").css("display", "none");
   $(".brown-variant").css("display", "none");
   $(".light-brown-variant").css("display", "none"); 
    $(".dark-brown-variant").css("display", "none");
   $(".black1-variant").css("display", "none");
  //alert('Grey color');
  } 
  else if(variant == 'Light Brown'){
   $(".light-brown-variant").css("display", "block"); 
   $(".grey-variant").css("display", "none");
   $(".medium-blonde-variant").css("display", "none");
   $(".dark-blonde-variant").css("display", "none");
   $(".black-variant").css("display", "none");
   $(".medium-brown-variant").css("display", "none");
   $(".brown-variant").css("display", "none");
   $(".dark-brown-variant").css("display", "none");
   $(".black1-variant").css("display", "none");
  //alert('Light Brown color');
  }
 else if(variant == 'black'){
   $(".black1-variant").css("display", "block");
   $(".light-brown-variant").css("display", "none");
   $(".grey-variant").css("display", "none");
   $(".medium-blonde-variant").css("display", "none");
   $(".dark-blonde-variant").css("display", "none");
   $(".black-variant").css("display", "none");
   $(".medium-brown-variant").css("display", "none");
   $(".brown-variant").css("display", "none");
   $(".dark-brown-variant").css("display", "none");
  //alert('Light Brown color');
  } 
 
});

});



/*jQuery(".SizeSwatch__Radio").click(function ()
{       
var variant = $(this).attr("value");
  if (variant == 'Black'){
  $(".brown-variant").css("display", "none");
    $(".black-variant").css("display", "block");
   //alert('Black color');
  }
  else if(variant == 'Brown'){
   $(".black-variant").css("display", "none");
    $(".brown-variant").css("display", "block");
  //alert('brown color');
  }
   
    });*/

// $(document).ready(function() {
// 	var s = $(".Product__InfoWrapper");
// 	var pos = s.position();					   
// 	$(window).scroll(function() {
// 		var windowpos = $(window).scrollTop();
// 		if (windowpos >= pos.top & windowpos <=800) {
// 			s.addClass("stick");
// 		} else {
// 			s.removeClass("stick");	
// 		}
// 	});
// });